import { companyPartnerIntegrationsService } from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface DeleteIntegrationParams {
  id: string;
  companyId: string;
}

const useDeleteIntegration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: DeleteIntegrationParams) =>
      companyPartnerIntegrationsService.deleteIntegration(id),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['fetchCompanyIntegrations', companyId] });
    },
  });
};

export default useDeleteIntegration;
